import { GTMEventsInterface } from '../interfaces';

export const GTMEvents: GTMEventsInterface = {
  APPLICATIONS_WORKSPACE: 'Applications_Workspace',
  APPLICATIONS_WORKSPACE_SELECT: 'Applications_Workspace_Select',
  APPLICATIONS_NAME: 'Applications_Name',
  APPLICATIONS_SUBMIT: 'Applications_Submit',
};
